import React, { Component } from 'react'
import PropTypes from 'prop-types'
import { decode, createMarkup } from 'lib/Utils'
import './index.scss'
import Angle from 'components/Angle'
import $ from 'jquery'
import { TweenMax, Power0, Power2 } from 'gsap'
import TimelineMax from 'gsap/TimelineMax'
import Close from 'assets/images/close.svg'

class JobPositionList extends Component {
  constructor (props) {
    super(props)
    this.state = {
      activeOffice: null,
      activeJob: {
        id: null,
        title: null,
        content: null
      }
    }

    this.lists = {}

    this.closeJobDisplay = this.closeJobDisplay.bind(this)
    this.timeline = new TimelineMax()
  }

  openSubList (el) {
    TweenMax.set(el, { height: 'auto' })
    TweenMax.from(el, 0.3, { height: 0, ease: Power2.easeOut })
  }

  closeSubList (el) {
    TweenMax.to(el, 0.3, { height: 0, ease: Power2.easeOut })
  }

  componentWillEnter (callback) {
    this.timeline
      .staggerFromTo(
        $(this.officesListEl).find('.office'),
        0.6,
        { x: '-120px', autoAlpha: 0 },
        { x: '0px', autoAlpha: 1, ease: Power2.easeOut, onComplete: callback },
        0.1,
        2
      )
  }

  componentDidUpdate (prevProps, prevState) {
    // Was there a change in the activeOffice state
    if (prevState.activeOffice !== this.state.activeOffice) {
      if (this.state.activeOffice !== null) {
        this.openSubList(this.lists[this.state.activeOffice])
      }
      if (prevState.activeOffice !== null) {
        this.closeSubList(this.lists[prevState.activeOffice])
      }
    }

    // Was there a change in the activeJob state
    if (prevState.activeJob.id !== this.state.activeJob.id) {
      if (prevState.activeJob.id === null) {
        let officesListWidth = window.innerWidth >= 768 ? 230 : 0
        let jobDisplayWidth = window.innerWidth >= 768 ? $(this.rootEl).width() - 230 : '100%'
        this.timeline
        .clear()
        .to(this.officesListEl, 0.6, { width: officesListWidth, paddingRight: 0, ease: Power2.easeOut }, 0)
        .to(this.jobDisplayEl, 0.6, { width: jobDisplayWidth, ease: Power2.easeOut }, 0)
        .to(this.jobDisplayEl, 0.3, { opacity: 1, ease: Power0.easeNone }, 0.3)
        .fromTo($(this.jobDisplayEl).find('.job-display__inner'), 0.6, { autoAlpha: 0 }, { autoAlpha: 1, ease: Power0.easeNone }, 0.6)
      } else if (this.state.activeJob.id === null) {
        let jobDisplayWidthClosed = window.innerWidth >= 1024 ? 160 : 30
        this.timeline
          .clear()
          .to(this.officesListEl, 0.6, { width: 610, ease: Power2.easeOut }, 0)
          .to(this.jobDisplayEl, 0.6, { width: jobDisplayWidthClosed, ease: Power2.easeOut }, 0)
          .to(this.jobDisplayEl, 0.3, { opacity: 0, ease: Power0.easeNone }, 0)
      }
    }
  }

  toggleOffice (officeID) {
    officeID = (officeID === this.state.activeOffice) ? null : officeID
    this.setState({ activeOffice: officeID })
  }

  selectJob (job) {
    this.setState({ activeJob: job })
  }

  renderJobs (jobs) {
    return jobs.map((job) => {
      let classes = (this.state.activeJob.id === job.id) ? 'active' : ''
      return (
        <li className={classes} key={job.id} onClick={(event) => this.selectJob({
          id: job.id,
          title: decode(job.title.rendered),
          content: job.content.rendered
        })}>
          <div>
            {decode(job.title.rendered)}
          </div>
        </li>
      )
    })
  }

  renderOffices () {
    return this.props.offices.map((office) => {
      if (office.job_positions.length === 0) {
        return
      }
      let classes = (this.state.activeOffice === office.id) ? 'active' : ''
      return (
        <li key={`office${office.id}`} className='office'>
          <div className={`office__name ${classes}`} onClick={(event) => this.toggleOffice(office.id)}>
            {decode(office.name)}
            <Angle />
          </div>
          <ul ref={el => { this.lists[office.id] = el }} className='office__jobs'>
            {this.renderJobs(office.job_positions)}
          </ul>
        </li>
      )
    }, this)
  }

  closeJobDisplay () {
    this.setState({
      activeJob: {
        id: null,
        title: null,
        content: null
      }
    })
  }

  render () {
    return (
      <div className='job-position-list' ref={el => { this.rootEl = el }}>
        <ul ref={el => { this.officesListEl = el }} className='offices-list'>
          {this.renderOffices()}
        </ul>
        <div ref={el => { this.jobDisplayEl = el }} className='job-display'>
          {
            this.state.activeJob.id !== null &&
            <div className='job-display__inner'>
              <div className='job-display__title'>
                <div className='title small-title'>{this.state.activeJob.title}</div>
                <div className='close-button' onClick={this.closeJobDisplay}>
                  <img src={Close} alt='Close' />
                </div>
              </div>
              <div className='job-display__content content' dangerouslySetInnerHTML={createMarkup(this.state.activeJob.content)} />
            </div>
          }
        </div>
      </div>
    )
  }
}

JobPositionList.propTypes = {
  offices: PropTypes.array
}

export default JobPositionList



// WEBPACK FOOTER //
// ./src/components/JobPositionList/index.js